__turbopack_context__.v({
  "body": "PromoTileCard-module-scss-module__OGHAzq__body",
  "card": "PromoTileCard-module-scss-module__OGHAzq__card",
  "content": "PromoTileCard-module-scss-module__OGHAzq__content",
  "cta": "PromoTileCard-module-scss-module__OGHAzq__cta",
  "ctaRow": "PromoTileCard-module-scss-module__OGHAzq__ctaRow",
  "heading": "PromoTileCard-module-scss-module__OGHAzq__heading",
  "image": "PromoTileCard-module-scss-module__OGHAzq__image",
  "imageWrapper": "PromoTileCard-module-scss-module__OGHAzq__imageWrapper",
  "scrim": "PromoTileCard-module-scss-module__OGHAzq__scrim",
  "srOnly": "PromoTileCard-module-scss-module__OGHAzq__srOnly",
});
